<template>
    <PageWrapper>
        <template #headline>
            <div class="flex h-auto w-full items-center justify-between">
                <div class="flex items-center gap-2">
                    <fa icon="fa-solid fa-signs-post" />
                    {{ $t('webhook_calls') }}
                </div>
            </div>
        </template>
        <WebhookCallsTable />
    </PageWrapper>
</template>

<script setup lang="ts">
import PageWrapper from '@src/partials/pages/PageWrapper.vue'
import WebhookCallsTable from '@src/partials/webhookCalls/WebhookCallsTable.vue'
</script>
